import React, { Component, useEffect, useState } from 'react';
import i18n from 'i18n-react';
import algoliasearch from 'algoliasearch';
import {
  InstantSearch,
  SearchBox,
  Index,
  Configure,
  Pagination,
  useInstantSearch,
} from 'react-instantsearch-hooks-web';

import { SearchHits } from 'C4';
import SearchFilters from '../../components/SearchFilters';

function NoResultsBoundary({ children, fallback }) {
  const { results } = useInstantSearch();
  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned yet.
  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }
  return children;
}

function NoResults() {
  return null;
}

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const SearchView = () => {
  const [numberOfHits, setNumberOfHits] = useState(8);
  useEffect(() => {
    debounceHandeleResize();
    window.addEventListener('resize', debounceHandeleResize);
    return (_) => {
      window.removeEventListener('resize', debounceHandeleResize);
    };
  }, []);

  const debounceHandeleResize = debounce(function hitsperpage() {
    if (window.innerWidth < 510) {
      setNumberOfHits(4);
    } else if (window.innerWidth < 1170) {
      setNumberOfHits(6);
    } else {
      setNumberOfHits(8);
    }
  }, 1000);
  const searchClient = algoliasearch('TRCCWLN5MZ', 'f93ec996b6352f6be2f9f55b4678c013');

  const indexes = ['chapters', 'pages', 'sales_companion_items', 'links'];

  const Hits = indexes.map((hitTypes) => (
    <div className="hitsRow" key={hitTypes}>
      <Index indexName={hitTypes} attributesForFaceting="filterOnly(category)">
        <div className="hitRowTitle">
          <h1>{hitTypes.replaceAll('_', ' ')}</h1>
        </div>
        <SearchFilters hitTypes={hitTypes} />
        <NoResultsBoundary fallback={<NoResults />}>
          <SearchHits className="searchRows" dataIndex={hitTypes}></SearchHits>
          <div className="paginationCon">
            <Pagination padding={2} />
          </div>
        </NoResultsBoundary>
      </Index>
    </div>
  ));

  return (
    <div className="searchView">
      <InstantSearch searchClient={searchClient} indexName="links" stalledSearchDelay={2000}>
        <Configure hitsPerPage={numberOfHits} filters={'app_id = 787'} />
        <div className="hitsContainer">
          <div className="container">
            <div className="searchBarContainer">
              <div className="header">
                <div className="headerText">
                  <h1>{i18n.translate('general.search')}</h1>
                  <p>{i18n.translate('pageDescriptions.search')}</p>
                </div>
                <div className="searchCon">
                  <SearchBox
                    searchAsYouType={false}
                    placeholder={i18n.translate('general.searchBarPlaceholder')}
                  ></SearchBox>
                </div>
              </div>
            </div>
            {Hits}
          </div>
        </div>
      </InstantSearch>
    </div>
  );
};
export default SearchView;
